import {
  resetPassword,
  confirmResetPassword,
  confirmSignUp,
  signUp,
  resendSignUpCode
} from 'aws-amplify/auth';

import { AuthenticatedAccount } from '@client:common/AuthenticatedAccount';

import { CreateAccountDto } from '../models/CreateAccountDto';

export class AccountManagerService {
  private static readonly _INSTANCE_ = new AccountManagerService();

  private constructor() {
  }

  static getInstance() {
    return AccountManagerService._INSTANCE_;
  }

  async sendPasswordRecoveryEmail(email: string) {
    try {
      // In v6, resetPassword replaces forgotPassword
      const data = await resetPassword({
        username: email.split('@')[0]
      });
      return data;
    } catch (error: any) {
      return Promise.reject(error);
    }
  }

  async changePassword(username: string, verificationCode: string, password: string) {
    try {
      // In v6, confirmResetPassword replaces forgotPasswordSubmit
      return await confirmResetPassword({
        username,
        confirmationCode: verificationCode,
        newPassword: password
      });
    } catch (error: any) {
      return Promise.reject(error.message.toLowerCase());
    }
  }

  async verifyAccount(username: string, code: string) {
    try {
      return await confirmSignUp({
        username,
        confirmationCode: code
      });
    } catch (error: any) {
      return Promise.reject(error.message.toLowerCase());
    }
  }

  async createAccount(createAccountDto: CreateAccountDto): Promise<AuthenticatedAccount> {
    try {
      await signUp({
        username: createAccountDto.email.split('@')[0],
        password: createAccountDto.password,
        options: {
          userAttributes: {
            email: createAccountDto.email,
            'custom:firstName': createAccountDto.firstName,
            'custom:lastName': createAccountDto.lastName,
            'custom:organization': createAccountDto.organization
          }
        }
      });

      return {
        email: createAccountDto.email,
        firstName: createAccountDto.firstName,
        lastName: createAccountDto.lastName,
        organization: createAccountDto.organization,
        accessToken: '',
        isVerified: false
      };
    } catch (error: any) {
      return Promise.reject(error.message.toLowerCase());
    }
  }

  async resendVerificationCode(username: string) {
    return await resendSignUpCode({
      username
    });
  }
}
